export class SearchField {
    private fields: Array<{ name: string, title?: string }> = [];

    addField(name: string, title?: string) {
       // this.fields.push({ name, title, rtfName });
        Object.assign(this.fields, [...this.fields, { name, title }]);
    }

    getJSONString(): string {
        const resultado = this.fields;
        return resultado?JSON.stringify(resultado):'';
    }

    getFieldCount(): number{
        return this.fields.length;
    }
    clear(){
        this.fields = [];
    }
}  

